import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { authClient } from "@/lib/auth-client";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ location }) => {
    const session = await authClient.getSession();
    if (!session?.data?.session) {
      throw redirect({
        to: "/login",
        search: { redirectUrl: location.pathname },
      });
    }
  },
  component: () => <Outlet />,
});
